exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuizList__QuizList--1Dlta{\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tpadding-top: 100px;\r\n\tflex-grow: 1;\r\n\twidth: 100%;\r\n\tbackground: linear-gradient(90deg, #fd8355 0%, #f0576c 37%, #f79cbd 100%);\r\n}\r\n\r\n.QuizList__QuizList--1Dlta h1{\r\n\tcolor: #fff;\r\n}\r\n\r\n.QuizList__QuizList--1Dlta ul{\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.QuizList__QuizList--1Dlta li{\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.QuizList__QuizList--1Dlta li a{\r\n\ttext-decoration: none;\r\n\tcolor:#fff;\r\n}\r\n\r\n.QuizList__QuizList--1Dlta li a:hover{\r\n\tcolor: #363f54;\r\n}", ""]);

// exports
exports.locals = {
	"QuizList": "QuizList__QuizList--1Dlta"
};